import React from 'react'

import { useI18N } from '../../../libraries/i18n/hook'
import RsvpAttendIcon from '../../../assets/icons/rsvp-attend.svg?react'

type Props = { attending?: boolean }
const RsvpTag: React.FC<Props> = () => {
  const { t } = useI18N()
  return (
    <div className='gap-x-2 sm:gap-x-1 uppercase text-2xs sm:text-xs flex items-center justify-around bg-deep-green text-white rounded-md px-3 py-1'>
      <RsvpAttendIcon />
      {t('events.rsvp.attending')}
    </div>
  )
}

export default RsvpTag
